import { useContext } from "react";

import { LabelWizardContext } from "./context";

export const useLabelWizard = () => {
  const context = useContext(LabelWizardContext);

  if (!context) {
    throw new Error(
      "useLabelWizard can only be used inside LabelWizardProvider",
    );
  }

  return context;
};
